import { render, staticRenderFns } from "./CertificateDisplay.vue?vue&type=template&id=11f1f18d"
import script from "./CertificateDisplay.vue?vue&type=script&lang=ts"
export * from "./CertificateDisplay.vue?vue&type=script&lang=ts"
import style0 from "./CertificateDisplay.vue?vue&type=style&index=0&id=11f1f18d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports